<!--
 * @Author: cmchiu
 * @Date: 2023-05-05 09:54:38
 * @LastEditTime: 2023-05-22 14:14:44
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\InstrumentSearch.vue
 * 
-->
<template>
    <div class="instrument-search">
        <breadcrumb />

        <div class="layer-container">
            <h2 class="page-title">貴重儀器設備</h2>
            <div class="equipment">
                <!-- Simple Search Bar -->
                <div class="simple-search w-100 d-flex">
                    <input
                        class="simple-search__input"
                        type="search"
                        id="search"
                        name="search"
                        placeholder="儀器名稱、廠牌"
                        v-model.trim="instrument.filter.keyword"
                        @keyup.enter="getInstLs(1)"
                        @change="getInstLs(1)"
                    />
                    <button class="simple-search__button" @click="getInstLs()">搜 尋</button>
                </div>
                <!-- Equipment -->
                <div class="equipment__wrapper">
                    <h3 class="page-subtitle">貴重儀器資訊</h3>
                    <table class="info-table">
                        <thead>
                            <tr>
                                <th>購置年度</th>
                                <th>儀器品名</th>
                                <th>廠牌</th>
                                <th>規格</th>
                                <th>所屬學院</th>
                                <th>保管單位</th>
                                <th>存置地點</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in instrument.data" :key="row.sno">
                                <td
                                    v-text="!row.PurchDate ? '----' : new Date(row.PurchDate).getFullYear() - 1911"
                                ></td>
                                <td v-text="row.TitleC"></td>
                                <td v-text="row.Brand"></td>
                                <td v-text="row.Spec"></td>
                                <td v-text="row.College"></td>
                                <td v-text="row.Dep"></td>
                                <td v-text="row.Place"></td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination
                        :page-size="instrument.pages.pageSize"
                        :total.sync="instrument.pages.totalResult"
                        :currPage.sync="instrument.pages.pageCurrent"
                        @page-change="pageChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getInstLs } from '@/api/instrument'
import { breadcrumb, pagination } from '@c'

export default {
    name: 'instrumentSearch',

    components: { breadcrumb, pagination },

    data() {
        const vm = this
        const rParas = vm.$route.params

        return {
            configs: {
                loading: false,
            },
            instrument: {
                filter: {
                    keyword: !rParas.keyword ? '' : rParas.keyword,
                },
                data: [],
                pages: {
                    totalResult: 0, // 總筆數
                    pageSize: 9, // 分頁大小
                    pageCurrent: 1, // 目前頁次
                },
            },
        }
    },

    created() {
        this.getInstLs(1)
    },

    methods: {
        async getInstLs(chgFilters) {
            const vm = this
            const filter = vm.instrument.filter
            const pages = vm.instrument.pages
            vm.configs.loading = true
            if (chgFilters) pages.pageCurrent = 1 //當條件改變時, 將當前頁次改回第1頁
            let params = {
                Keyword: filter.keyword,
                PageSize: pages.pageSize,
                PageCurrent: pages.pageCurrent,
            }
            await getInstLs(params)
                .then(res => {
                    // handle success
                    vm.instrument.data = res.Items
                    pages.totalResult = res.TotalResult
                    if (Math.ceil(pages.totalResult / pages.pageSize) < pages.pageCurrent) {
                        pages.pageCurrent = 1
                    }
                })
                .catch(err => {
                    // handle error
                    vm.instrument.data = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },

        pageChange(val) {
            this.instrument.pages.pageCurrent = val
            this.getInstLs()
        },
    },
}
</script>
